import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DOMPurify from 'isomorphic-dompurify';
import { cn } from '@/utils/cn';

interface MarkdownViewProps {
  content: string;
  className?: string;
}

export function MarkdownView({ content, className }: MarkdownViewProps) {
  const sanitized = DOMPurify.sanitize(content);
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none',
        'prose-headings:font-semibold prose-headings:text-ds-text',
        'prose-p:text-ds-text-2',
        'prose-code:rounded prose-code:bg-ds-sunk prose-code:px-1 prose-code:py-0.5',
        'prose-pre:rounded-lg prose-pre:bg-ds-sunk',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{sanitized}</ReactMarkdown>
    </div>
  );
}
